import TabWithPulse from "features/VehicleSidebar/AffectedTrains/TabWithPulse";
import { Box, Flex, HStack, TabsContent } from "shared/components/Spor";
import { hideScrollbar } from "shared/utils/hideScrollbar";
import styled from "styled-components";

export const AffectedTrainGrid = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px;
  background: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: 6px;
`;

export const VStackContainer = styled.div`
  container-type: inline-size;
  container-name: VStackContainer;
`;

export const VStackWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 6px;

  grid-template-areas:
    "trainId"
    "stations"
    "affected"
    "badge";
  align-items: center;

  @container VStackContainer (width > 300px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "trainId affected"
      "stations affected"
      "badge affected";
  }

  @container VStackContainer (width > 500px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      "trainId badge affected"
      "stations badge affected";
  }
`;

export const AffectedTrainsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;

export const StyledTabsContents = styled(Flex)`
  overflow: hidden;
  height: 100%;
  ${hideScrollbar}
`;

export const StyledTabsContent = styled(TabsContent)`
  width: 100%;
  height: 100%;
  border-radius: 6px;
`;

export const TabPanelContent = styled.div`
  height: 100%;
`;

export const InfoBox = styled(Box)`
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  margin-top: 6px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
  color: ${({ theme }) => theme.colorTextSecondary};
  background: ${({ theme }) => theme.colorBackgroundMain};
  container-type: inline-size;

  p {
    @container (width < 350px) {
      font-size: 14px !important;
    }
  }
`;

export const ButtonGroupFitter = styled(HStack)`
  padding: 12px;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  height: 54px;
`;

export const StyledTabWithPulse = styled(TabWithPulse)`
  max-width: 10px;
  * * {
    max-width: 10px;
  }
`;
